
<div class="employee-view">
  <page-header :title="employeeLabel">
    <template #actions>
      <icon-button
        icon="list"
        tooltip="Audit Log"
        @click="$router.push(`/audit?employee=${$route.params.id}`)"
      />
    </template>
  </page-header>

  <section v-if="loaded">
    <div class="widget">
      <align class="header" flex>
        <h3 class="secondary-font">
          Verify Cards
        </h3>
      </align>

      <div class="grid">
        <stat-item
          size="xlarge"
          success
          label="Progress"
          :value="$filters.number(employee.progressCount)"
        />

        <stat-item
          size="xlarge"
          success
          label="Review"
          :value="$filters.number(employee.reviewCount)"
        />

        <stat-item
          size="xlarge"
          success
          label="Back to Progress Weekly"
          :value="$filters.number(employee.weeklyMovedBackCount)"
        />

        <stat-item
          size="xlarge"
          success
          label="Back to Progress Monthly"
          :value="$filters.number(employee.monthlyMovedBackCount)"
        />
      </div>
    </div>

    <div class="widget">
      <align class="header" flex>
        <h3 class="secondary-font">
          Cards Added
        </h3>
      </align>

      <div class="grid">
        <stat-item
          size="xlarge"
          success
          label="Added Weekly"
          :value="$filters.number(employee.weeklyAddedCount)"
        />

        <stat-item
          size="xlarge"
          success
          label="Added Monthly"
          :value="$filters.number(employee.monthlyAddedCount)"
        />

        <stat-item
          size="xlarge"
          success
          label="Total Cards"
          :value="$filters.number(employee.totalAddedCount)"
        />
      </div>
    </div>

    <div class="widget">
      <align class="header" flex>
        <h3 class="secondary-font">
          Pending Sales
        </h3>
      </align>

      <div class="grid">
        <stat-item
          size="xlarge"
          success
          label="Reviewed Monthly"
          :value="$filters.number(employee.pendingSalesCount)"
        />

        <stat-item
          size="xlarge"
          success
          label="Average Lifespan of Pending"
          :value="$filters.duration(employee.pendingSalesDuration)"
        />
      </div>
    </div>
  </section>

  <spinner v-else />
</div>
